import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutPreview from "./components/AboutPreview";
import ServicesPreview from "./components/ServicesPreview";
import MyWork from "./components/MyWork";
import Portfolio from "./components/Portfolio";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Hero />
          <AboutPreview />
          <ServicesPreview />
          <MyWork />
          <Portfolio />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;